// extracted by mini-css-extract-plugin
export default {"grid":"SummaryCards_grid__ebePv","card":"SummaryCards_card__XPcdp","icon":"SummaryCards_icon__x6INs","value":"SummaryCards_value__8UHLp","label":"SummaryCards_label__QsSeH"};